// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__iS2U4","title":"ClientCherryInfo_title__-e-8u","itemText":"ClientCherryInfo_itemText__1e2Dj"};